import { Service } from "../model/service/Service";

export class ServicePostCommand{
    service:Service;

    constructor(service:Service){
        this.service = service;
    }
}